module.exports = __webpack_public_path__ + "static/media/instruction.4de3f621.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/instruction.png
// module id = 1168
// module chunks = 0